<template>
    <div class="bus-history__drop-route">
        <el-row>
            <el-form :inline="true">
                <el-form-item :label="$t('common.date')">
                    <el-date-picker
                            v-model="date"
                            type="date"
                            :placeholder="$t('common.pick_a_day')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('common.bus')">
                    <el-select v-model="busId" :placeholder="$t('common.bus')">
                        <el-option
                                v-for="bus in busList"
                                :key="bus.id"
                                :label="bus.name"
                                :value="bus.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search()" :disabled="!date || !busId">{{ $t('common.search') }}</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <table class="history-student-list">
            <tr>
                <th width="5%">#</th>
                <th width="10%">{{ $t('common.full_name') }}</th>
                <th width="10%">{{ $t('common.romaji') }}</th>
                <th width="10%">{{ $t('common.furigana') }}</th>
                <th width="5%">{{ $t('common.class') }}</th>
                <th width="10%">{{ $t('common.bus_stop') }}</th>
                <th width="10%">{{ $t('common.status') }}</th>
                <th width="5%">{{ $t('common.time') }}</th>
                <th width="10%">{{ $t('common.checked_in') }}</th>
                <th width="10%">{{ $t('common.checked_out') }}</th>
                <th width="10%">{{ $t('common.note') }}</th>
                <th></th>
            </tr>
            <BusHistoryDropRouteItem
                    v-for="(student, index) in sortedHistoryStudentList"
                    :key="`${keyGenerate}_${student.id}`"
                    :student="student"
                    :index="index"
                    :bus-id="busId"
                    :date="date">
            </BusHistoryDropRouteItem>
        </table>
        <el-row style="padding-top: 20px;" v-if="canAdd()">
            <el-form :inline="true">
                <el-form-item :label="$t('common.student')">
                    <el-select v-model="studentId" filterable :placeholder="$t('common.please_select')">
                        <el-option
                                v-for="student in studentList"
                                :key="student.id"
                                :label="`${student.name}${student.romaji ? ' (' + student.romaji + ')' : ''}${student.class_info ? ' - ' + student.class_info.name : ''}`"
                                :value="student.id"
                                :disabled="isDisabled(student)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('common.time')">
                    <el-select v-model="time" :placeholder="$t('common.please_select')" v-if="timeList.length">
                        <el-option
                                v-for="time in timeList"
                                :key="time"
                                :label="time"
                                :value="time">
                        </el-option>
                    </el-select>
                    <el-time-select v-else
                            v-model="time"
                            :picker-options="pickerOptions"
                            :placeholder="$t('common.please_select')">
                    </el-time-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addStudent()" :disabled="!studentId || !time">{{ $t('common.add') }}</el-button>
                </el-form-item>
            </el-form>
        </el-row>
    </div>
</template>

<script>
  import { ROUTE_DROP, GENERATE_TIME_DROP } from "../../config"
  import BusHistoryDropRouteItem from "./BusHistoryDropRouteItem"
  import { timeSort, basicSort } from '@/utils'

  export default {
    name: 'BusHistoryDropRoute',
    props: ['busList', 'studentList'],
    components: {
      BusHistoryDropRouteItem
    },
    data: function () {
      return {
        date: this.$moment(),
        busId: null,
        historyStudentList: [],
        keyGenerate: 0,
        pickerOptions: {
          start: '12:00',
          step: '00:15',
          end: '20:00'
        },
        choseBusId: null,
        studentId: null,
        time: null
      }
    },
    methods: {
      search: function () {
        if (this.date && this.busId) {
          let date = this.$moment(this.date).format('YYYY-MM-DD')
          let busId = this.busId
          let successCallback = (response) => {
            if (response.data.data.student_list) {
              this.historyStudentList = [].concat(response.data.data.student_list)
              this.keyGenerate++
            }

            this.choseBusId = busId
            this.studentId = null
            this.time = null
          }

          this.$store.dispatch('bus/retrieveBusHistoryStudentList', {
            date,
            busId,
            routeType: ROUTE_DROP,
            successCallback
          })
        }
      },
      isDisabled (student) {
        let historyStudent = this.historyStudentList.find((item) => {
          return item.id === student.id
        })

        return typeof historyStudent !== 'undefined'
      },
      addStudent: function () {
        if (this.date && this.busId && this.studentId) {
          let date = this.$moment(this.date).format('YYYY-MM-DD')
          let busId = this.busId
          let studentId = this.studentId
          let time = this.time
          let successCallback = (response) => {
            if (response.data.data.student_info) {
              this.historyStudentList.push(response.data.data.student_info)
            }

            this.studentId = null
            this.time = null
          }

          this.$store.dispatch('bus/busHistoryAddStudent', {
            date,
            busId,
            studentId,
            time,
            routeType: ROUTE_DROP,
            successCallback
          })
        }
      },
      canAdd: function () {
        if (!this.choseBusId) {
          return false
        }

        let date = this.$moment(this.date).format('YYYY-MM-DD')
        let currentDate = this.$moment().format('YYYY-MM-DD')

        if (date > currentDate) {
          return false
        } else if (date === currentDate) {
          let currentTime = this.$moment().format('H:mm')

          if (timeSort(currentTime, GENERATE_TIME_DROP) <= 0) {
            return false
          }
        }

        return true
      }
    },
    computed: {
      sortedHistoryStudentList: function () {
        let sortedHistoryStudentList = [].concat(this.historyStudentList)
        return sortedHistoryStudentList.sort((before, after) => {
          let placeSort = basicSort(before, after, 'place_name')

          if (placeSort) {
            return placeSort
          }
          let classSort = basicSort(before, after, 'class_name')
          return classSort

        })
      },

      timeList: function () {
        let timeList = []

        this.historyStudentList.forEach((item) => {
          if (timeList.indexOf(item.time) === -1) {
            timeList.push(item.time)
          }
        })

        return timeList.sort((before, after) => timeSort(before, after))
      }
    }
  }
</script>
